<!-- DDCFB -->
<div
  *ngIf="switchingAccountService.getDisplayStatus() || showSwitchPage"
  [attr.aria-label]="displayAccountSwitchingText"
  class="switch-account-overlay"
  id="switch-account-overlay"
>
  <div
    [ngStyle]="{'background-image':'url(' + displayBackgroundImage + ')'}"
    class="account-switch-background"
  ></div>
  <!--<img class="account-switch-background" src="{{displayBackgroundImage}}">-->
  <div
    [attr.aria-label]="displayAccountSwitchingText"
    aria-live="assertive"
    class="switch-account-logo"
  >
    <img class="siteLogo" src="{{bannerDetails.businessLogo}}" />
  </div>
  <div class="switch-account-loading">
    <img class="loadingLogo" src="{{bannerDetails.progressImageUrl}}" />
  </div>
  <div class="switch-account-content OneLinkNoTx">
    <span innerHTML="{{displayAccountSwitchingText}}"></span>
  </div>
</div>
